interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
}: SEOMetaProps) {
  const fullTitle = title.includes('樱花动漫91') ? title : `${title} - 樱花动漫91`;
  const ogImageUrl = ogImage || 'https://readdy.ai/api/search-image?query=Sakura%20anime%20manga%20website%20banner%20with%20pink%20cherry%20blossoms%2C%20manga%20covers%20scattered%2C%20soft%20warm%20lighting%2C%20Japanese%20aesthetic%2C%20clean%20modern%20design&width=1200&height=630&seq=og-default&orientation=landscape';

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:site_name" content="樱花动漫91" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageUrl} />

      {articlePublishedTime && <meta property="article:published_time" content={articlePublishedTime} />}
      {articleModifiedTime && <meta property="article:modified_time" content={articleModifiedTime} />}

      <link rel="alternate" hrefLang="zh-Hans" href={canonicalUrl} />
    </>
  );
}